













































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import noticeBoardService from '@/services/notice-board.service';
import { NoticeBoardDto } from '@/dto/notice-board/notice-board.dto';

@Component({
  name: 'NoticeBoardDetail',
})
export default class NoticeBoardDetail extends BaseComponent {
  private noticeBoardDto = new NoticeBoardDto();

  getDetail() {
    noticeBoardService.findOne(this.$route.params.id).subscribe(res => {
      this.noticeBoardDto = res.data;
    });
  }
  forceFileDownload(response, fileName) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
  }
  downloadWithVueResource(filePath, fileName) {
    this.$http.get(filePath, { responseType: 'arraybuffer' }).then(res => {
      this.forceFileDownload(res, fileName);
    });
  }
  created() {
    this.getDetail();
  }
}
